module.exports = __webpack_public_path__ + "img/buy-car300x169.db6e653c.png";